import React from 'react';
import styles from './page5.scss';
import pic from './pic.png';
import { getRem } from '../../func';

function page5(props) {
  return (
    <div className={styles['page5']} ref={props.myRef}>
      <div className={styles['page5-main']}>
        <div className={styles['page5-main-left']}>
          <div className={`${styles['page5-title']} animate2-wrapper`}>
            <div r='220' g='221' b='235' className={`maskBlock animate2`} style={{ background: 'rgb(220, 221, 235)' }} />
            OUR<br />
            ADVANTAGE
          </div>

          <div className={styles['page5-subTitle']}>
            <div className={styles['page5-subTitle-circle']}>5</div>
            <div className={styles['page5-subTitle-text']}>我们的优势 - <span style={{ color: '#32535D' }}>创新</span></div>
          </div>

          <div className={styles['page5-content']}>
            <div className={styles['page5-content-title']}>
              CONTINUOUSLY<br />
              UPGRADE<span style={{ fontSize: getRem(16), color: '#295A57', position: 'relative', top: getRem(-3), left: getRem(3) }}>不断升级创新的服务</span><br />
              INNOVATIVE SERVICES

              <div className={styles['titleNumber']}>1</div>
            </div>
            <div className={`${styles['page5-content-desc']} animate1-wrapper`}>
              <div r='220' g='221' b='235' className={`maskBlock animate1`} style={{ background: 'rgb(220, 221, 235)' }} />
              我们一直在探索更高效的服务模式、更具落地性的产品内容，如：我们创新性推出的时尚资讯APP知潮范，结合了智能数据与趋势资讯，满足用户更人性化的搜索体验；趋势网站与实体书籍每月持续优化板块内容及呈现方式，以创新的方式传递趋势美学，有效提高用户汲取信息的效率。
            </div>

            <div className={styles['page5-content-title']} style={{ marginTop: getRem(85) }}>
              <span style={{ fontSize: getRem(16), color: '#295A57' }}>引领行业未来的思维</span><br />
              LEADING THE FUTURE<br />
              OF THE INDUSTRY

              <div className={styles['titleNumber']} style={{ left: getRem(-57.5) }}>2</div>
            </div>
            <div className={`${styles['page5-content-desc']} animate1-wrapper`}>
              <div r='220' g='221' b='235' className={`maskBlock animate1`} style={{ background: 'rgb(220, 221, 235)' }} />
              我们不断自我革新、打破常规的格局，运用创新的思维让WOW-TREND为时尚行业指引更清晰的未来。
            </div>
          </div>
        </div>

        <div className={styles['page5-main-right']}>
          <img src={pic} />
        </div>

        <div className={styles['page5-icon']} style={{ position: 'absolute', bottom: '0' }}>
          <div className={styles.text}>INNOVATION</div>
          <div className={styles.area}></div>
        </div>
      </div>
    </div>
  );
}

export default page5;